<template>
    <div id="app">
        <router-view v-if="$store.state.db"></router-view>
    </div>
</template>

<script>
    import mqtt from "mqtt";
    import {
        GetBaseInfo,
    } from "./components/Request"
    import {
        connect,
        subscribeByNodes,
        unsubscribeByNodes
    } from "./mqtt/index"

    export default {
        name: "App",
        data() {
            return {}
        },
        async created() {
            await GetBaseInfo({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                this.influxDbName = data.data.project.influxDbName
                let gisUrl = data.data.project.webgisUrl.split('/')
                let len = gisUrl.length

                this.$store.commit("set_val", {
                    gisUrl: gisUrl[len - 1],
                    db: this.influxDbName
                });
                // this.mqttConnect();
            }).then(() => {
                connect()
                subscribeByNodes(["Ua", "Ub", "Uc", "Ia", "Ib", "Ic", "PA", "PR", "P", "PF", "U_unbl",
                    "I_unbl", "SwitchOn"
                ])
            })
            // await connect()
        },
        async mounted() {
            let html = document.getElementsByTagName("html")[0];
            this.reset(html)
            window.onresize = () => {
                this.reset(html)
            }
        },
        methods: {
            reset(html) {
                html.style.fontSize = window.innerWidth * window.innerHeight / 1920 / 1080 + 'px'
            },
            mqttConnect() {
                var client = mqtt.connect("mqtt://local.vrmaker.vip:8083/mqtt", {
                    username: "vrmaker",
                    password: "vrmaker",
                });

                client.on("connect", () => {
                    console.log("Mqtt connected ...");
                    let nodes = ['P', 'PA_total', 'PF', 'PR', 'PA', 'Ia', 'Ib', 'Ic', 'Ua', 'Ub', 'Uc', 'Uab',
                        'Uac', 'Ubc', 'Temperature', 'Temperature_A', 'Temperature_B', 'Temperature_C',
                        'SwitchOn', 'THD_U'
                    ]
                    let topic = []
                    nodes.forEach(item => {
                        topic.push(`VrMaker/${this.influxDbName}/+/PUBLISH/+/+/${item}`)
                        topic.push(`VrMaker/${this.influxDbName}/+/PUBLISH/+/+/+/${item}`)
                    })
                    // client.subscribe([`VrMaker/${this.influxDbName}/+/PUBLISH/#`]);
                    client.subscribe(nodes);
                });

                client.on("message", (topic, message) => {

                    let keys = topic.split('/')
                    let len = keys.length
                    let devicesName = keys.slice(4, len - 1).join('/')
                    let topicName = keys.slice(4).join('/')

                    // console.log(topicName, Number(message));

                    this.$store.commit("addMQTTData", {
                        key: topicName,
                        val: message,
                    });
                });

                client.on("error", (err) => {
                    console.log("mqtt error !!!", err);
                    client.end();
                });

                client.on("close", () => {
                    console.log("mqtt closed!");
                });
            },
        },
    };
</script>

<style lang="less">
    @import "./assets/fonts/font.css";
    @import "./assets/css/global";
    @import "./assets/css/func";
</style>